var map = {
	"./add-circle.svg": [
		"./src/components/icon/imgs/add-circle.svg",
		274
	],
	"./add-device.svg": [
		"./src/components/icon/imgs/add-device.svg",
		275
	],
	"./add-icon.svg": [
		"./src/components/icon/imgs/add-icon.svg",
		276
	],
	"./add-square.svg": [
		"./src/components/icon/imgs/add-square.svg",
		277
	],
	"./add.svg": [
		"./src/components/icon/imgs/add.svg",
		278
	],
	"./after-payments.svg": [
		"./src/components/icon/imgs/after-payments.svg",
		279
	],
	"./alarm.svg": [
		"./src/components/icon/imgs/alarm.svg",
		280
	],
	"./apply-filter.svg": [
		"./src/components/icon/imgs/apply-filter.svg",
		281
	],
	"./arrow-icon.svg": [
		"./src/components/icon/imgs/arrow-icon.svg",
		282
	],
	"./arrow-left.svg": [
		"./src/components/icon/imgs/arrow-left.svg",
		283
	],
	"./arrow-right.svg": [
		"./src/components/icon/imgs/arrow-right.svg",
		284
	],
	"./arrow-up-right.svg": [
		"./src/components/icon/imgs/arrow-up-right.svg",
		285
	],
	"./bar-report.svg": [
		"./src/components/icon/imgs/bar-report.svg",
		286
	],
	"./beer-count-one.svg": [
		"./src/components/icon/imgs/beer-count-one.svg",
		287
	],
	"./beer.svg": [
		"./src/components/icon/imgs/beer.svg",
		288
	],
	"./blocked.svg": [
		"./src/components/icon/imgs/blocked.svg",
		289
	],
	"./brazil.svg": [
		"./src/components/icon/imgs/brazil.svg",
		290
	],
	"./buyer-recharge.svg": [
		"./src/components/icon/imgs/buyer-recharge.svg",
		291
	],
	"./camera.svg": [
		"./src/components/icon/imgs/camera.svg",
		292
	],
	"./cash-bag.svg": [
		"./src/components/icon/imgs/cash-bag.svg",
		293
	],
	"./cash-withdrawal.svg": [
		"./src/components/icon/imgs/cash-withdrawal.svg",
		294
	],
	"./chair.svg": [
		"./src/components/icon/imgs/chair.svg",
		295
	],
	"./check-icon.svg": [
		"./src/components/icon/imgs/check-icon.svg",
		296
	],
	"./check-payment-give.svg": [
		"./src/components/icon/imgs/check-payment-give.svg",
		297
	],
	"./check-small.svg": [
		"./src/components/icon/imgs/check-small.svg",
		298
	],
	"./check.svg": [
		"./src/components/icon/imgs/check.svg",
		299
	],
	"./chevron-arrow.svg": [
		"./src/components/icon/imgs/chevron-arrow.svg",
		300
	],
	"./chevron-back.svg": [
		"./src/components/icon/imgs/chevron-back.svg",
		301
	],
	"./chevron-double-left.svg": [
		"./src/components/icon/imgs/chevron-double-left.svg",
		302
	],
	"./chevron-double-right.svg": [
		"./src/components/icon/imgs/chevron-double-right.svg",
		303
	],
	"./chevron-down.svg": [
		"./src/components/icon/imgs/chevron-down.svg",
		304
	],
	"./chevron-down2.svg": [
		"./src/components/icon/imgs/chevron-down2.svg",
		305
	],
	"./chevron-right.svg": [
		"./src/components/icon/imgs/chevron-right.svg",
		306
	],
	"./chevron-up.svg": [
		"./src/components/icon/imgs/chevron-up.svg",
		307
	],
	"./clear.svg": [
		"./src/components/icon/imgs/clear.svg",
		308
	],
	"./clock.svg": [
		"./src/components/icon/imgs/clock.svg",
		309
	],
	"./copy.svg": [
		"./src/components/icon/imgs/copy.svg",
		310
	],
	"./costumers.svg": [
		"./src/components/icon/imgs/costumers.svg",
		311
	],
	"./couvert.svg": [
		"./src/components/icon/imgs/couvert.svg",
		312
	],
	"./data-export-dark.svg": [
		"./src/components/icon/imgs/data-export-dark.svg",
		313
	],
	"./data-export.svg": [
		"./src/components/icon/imgs/data-export.svg",
		314
	],
	"./delete.svg": [
		"./src/components/icon/imgs/delete.svg",
		315
	],
	"./delivery-person.svg": [
		"./src/components/icon/imgs/delivery-person.svg",
		316
	],
	"./dollar-money.svg": [
		"./src/components/icon/imgs/dollar-money.svg",
		317
	],
	"./download.svg": [
		"./src/components/icon/imgs/download.svg"
	],
	"./drop-percentage.svg": [
		"./src/components/icon/imgs/drop-percentage.svg",
		318
	],
	"./edit-square.svg": [
		"./src/components/icon/imgs/edit-square.svg",
		319
	],
	"./edit.svg": [
		"./src/components/icon/imgs/edit.svg",
		320
	],
	"./email-icon.svg": [
		"./src/components/icon/imgs/email-icon.svg",
		321
	],
	"./email.svg": [
		"./src/components/icon/imgs/email.svg",
		322
	],
	"./empty-search.svg": [
		"./src/components/icon/imgs/empty-search.svg",
		323
	],
	"./empty-state.svg": [
		"./src/components/icon/imgs/empty-state.svg",
		324
	],
	"./exchange.svg": [
		"./src/components/icon/imgs/exchange.svg",
		325
	],
	"./external.svg": [
		"./src/components/icon/imgs/external.svg",
		326
	],
	"./file-check.svg": [
		"./src/components/icon/imgs/file-check.svg",
		327
	],
	"./filter.svg": [
		"./src/components/icon/imgs/filter.svg",
		328
	],
	"./financial-report.svg": [
		"./src/components/icon/imgs/financial-report.svg",
		329
	],
	"./french.svg": [
		"./src/components/icon/imgs/french.svg",
		330
	],
	"./history.svg": [
		"./src/components/icon/imgs/history.svg",
		331
	],
	"./home.svg": [
		"./src/components/icon/imgs/home.svg",
		332
	],
	"./hop-flower.svg": [
		"./src/components/icon/imgs/hop-flower.svg",
		333
	],
	"./image-stock.svg": [
		"./src/components/icon/imgs/image-stock.svg",
		334
	],
	"./inconsistencies.svg": [
		"./src/components/icon/imgs/inconsistencies.svg",
		335
	],
	"./info-outlined.svg": [
		"./src/components/icon/imgs/info-outlined.svg",
		336
	],
	"./info.svg": [
		"./src/components/icon/imgs/info.svg"
	],
	"./link.svg": [
		"./src/components/icon/imgs/link.svg",
		337
	],
	"./mail.svg": [
		"./src/components/icon/imgs/mail.svg",
		338
	],
	"./mexico.svg": [
		"./src/components/icon/imgs/mexico.svg",
		339
	],
	"./minus.svg": [
		"./src/components/icon/imgs/minus.svg",
		340
	],
	"./money-atm.svg": [
		"./src/components/icon/imgs/money-atm.svg",
		341
	],
	"./money-bag.svg": [
		"./src/components/icon/imgs/money-bag.svg",
		342
	],
	"./money-circle.svg": [
		"./src/components/icon/imgs/money-circle.svg",
		343
	],
	"./money-sign.svg": [
		"./src/components/icon/imgs/money-sign.svg",
		344
	],
	"./money.svg": [
		"./src/components/icon/imgs/money.svg",
		345
	],
	"./multivendor.svg": [
		"./src/components/icon/imgs/multivendor.svg",
		346
	],
	"./navigate-page.svg": [
		"./src/components/icon/imgs/navigate-page.svg",
		347
	],
	"./options.svg": [
		"./src/components/icon/imgs/options.svg",
		348
	],
	"./order-alphabetic.svg": [
		"./src/components/icon/imgs/order-alphabetic.svg",
		349
	],
	"./order-clock.svg": [
		"./src/components/icon/imgs/order-clock.svg",
		350
	],
	"./pdv-money.svg": [
		"./src/components/icon/imgs/pdv-money.svg",
		351
	],
	"./percentage.svg": [
		"./src/components/icon/imgs/percentage.svg",
		352
	],
	"./phone.svg": [
		"./src/components/icon/imgs/phone.svg",
		353
	],
	"./price.svg": [
		"./src/components/icon/imgs/price.svg",
		354
	],
	"./printer.svg": [
		"./src/components/icon/imgs/printer.svg",
		355
	],
	"./product-add.svg": [
		"./src/components/icon/imgs/product-add.svg",
		356
	],
	"./product-cancel.svg": [
		"./src/components/icon/imgs/product-cancel.svg",
		357
	],
	"./product-return.svg": [
		"./src/components/icon/imgs/product-return.svg",
		358
	],
	"./product-sells.svg": [
		"./src/components/icon/imgs/product-sells.svg",
		359
	],
	"./products.svg": [
		"./src/components/icon/imgs/products.svg",
		360
	],
	"./rasps.svg": [
		"./src/components/icon/imgs/rasps.svg",
		361
	],
	"./recharge-info.svg": [
		"./src/components/icon/imgs/recharge-info.svg",
		362
	],
	"./refresh.svg": [
		"./src/components/icon/imgs/refresh.svg",
		363
	],
	"./refund-reason.svg": [
		"./src/components/icon/imgs/refund-reason.svg",
		364
	],
	"./refund.svg": [
		"./src/components/icon/imgs/refund.svg",
		365
	],
	"./relations.svg": [
		"./src/components/icon/imgs/relations.svg",
		366
	],
	"./remove-circle.svg": [
		"./src/components/icon/imgs/remove-circle.svg",
		367
	],
	"./sale-slip-disabled.svg": [
		"./src/components/icon/imgs/sale-slip-disabled.svg",
		368
	],
	"./sale-slip.svg": [
		"./src/components/icon/imgs/sale-slip.svg",
		369
	],
	"./search-dark.svg": [
		"./src/components/icon/imgs/search-dark.svg",
		370
	],
	"./search.svg": [
		"./src/components/icon/imgs/search.svg",
		371
	],
	"./send-icon.svg": [
		"./src/components/icon/imgs/send-icon.svg",
		372
	],
	"./settings.svg": [
		"./src/components/icon/imgs/settings.svg",
		373
	],
	"./shine.svg": [
		"./src/components/icon/imgs/shine.svg",
		374
	],
	"./shopping-cart.svg": [
		"./src/components/icon/imgs/shopping-cart.svg",
		375
	],
	"./short-arrow-down.svg": [
		"./src/components/icon/imgs/short-arrow-down.svg",
		376
	],
	"./smartphone.svg": [
		"./src/components/icon/imgs/smartphone.svg",
		377
	],
	"./spain.svg": [
		"./src/components/icon/imgs/spain.svg",
		378
	],
	"./stock-report.svg": [
		"./src/components/icon/imgs/stock-report.svg",
		379
	],
	"./table.svg": [
		"./src/components/icon/imgs/table.svg",
		380
	],
	"./tag-alert.svg": [
		"./src/components/icon/imgs/tag-alert.svg",
		381
	],
	"./three-dots-icon.svg": [
		"./src/components/icon/imgs/three-dots-icon.svg",
		382
	],
	"./ticket.svg": [
		"./src/components/icon/imgs/ticket.svg",
		383
	],
	"./timezone.svg": [
		"./src/components/icon/imgs/timezone.svg",
		384
	],
	"./totem.svg": [
		"./src/components/icon/imgs/totem.svg",
		385
	],
	"./trash.svg": [
		"./src/components/icon/imgs/trash.svg",
		386
	],
	"./upload.svg": [
		"./src/components/icon/imgs/upload.svg",
		387
	],
	"./uploaded-file.svg": [
		"./src/components/icon/imgs/uploaded-file.svg",
		388
	],
	"./usa.svg": [
		"./src/components/icon/imgs/usa.svg",
		389
	],
	"./user-delete.svg": [
		"./src/components/icon/imgs/user-delete.svg",
		390
	],
	"./users-dark.svg": [
		"./src/components/icon/imgs/users-dark.svg",
		391
	],
	"./users.svg": [
		"./src/components/icon/imgs/users.svg",
		392
	],
	"./view.svg": [
		"./src/components/icon/imgs/view.svg",
		393
	],
	"./warning-circle.svg": [
		"./src/components/icon/imgs/warning-circle.svg",
		394
	],
	"./warning-icon.svg": [
		"./src/components/icon/imgs/warning-icon.svg",
		395
	],
	"./warning-triangular.svg": [
		"./src/components/icon/imgs/warning-triangular.svg",
		396
	],
	"./warning.svg": [
		"./src/components/icon/imgs/warning.svg",
		397
	],
	"./whatsapp.svg": [
		"./src/components/icon/imgs/whatsapp.svg",
		398
	],
	"./withdraw.svg": [
		"./src/components/icon/imgs/withdraw.svg",
		399
	],
	"./ze-delivery-tag.svg": [
		"./src/components/icon/imgs/ze-delivery-tag.svg",
		87
	],
	"./ze-delivery.svg": [
		"./src/components/icon/imgs/ze-delivery.svg",
		88
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/components/icon/imgs lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;